import { Module } from '@nestjs/common';
import { TypeOrmModule } from '@nestjs/typeorm';
import { DestinationAdapter } from './dto/destination.adapter';
import { Destination } from './destination.entity';
import { DestinationController } from './destination.controller';
import { DestinationService } from './destination.service';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { LogsService } from '@gtpl/shared-services/user-logs';

@Module({
  imports: [
    TypeOrmModule.forFeature([Destination]),
    ],
  controllers: [DestinationController],
  providers: [DestinationAdapter,DestinationService,ApplicationExceptionHandler,LogsService]
})
export class DestinationModule {

  
}
